module.exports = __webpack_public_path__ + "static/media/icon-android-wht-circle.16be6ac7.svg";